export default {
    agroServe: {
        Description: {
            title1:'National-Level Authenticity and Quality Assurance Service',
            title2:'Enterprise Digital Integrated Application Services',
            title3:'Digital services provided by the government in the producing areas',
            module1: {
                title: 'Premium Testing & Certification with Global Recognition for Secure Supply',
                text: 'National-level quality assurance system (Standard Center, Testing Center, Quality Evaluation Center) provides standardized testing and quality evaluation services, enabling global "mutual recognition of production and testing", "food safety and high-quality supply", and "premium pricing for premium products"!',
                box1: {
                    title: 'Standard Center',
                    text: 'Provides agricultural supply chain standard development, implementation, feedback and optimization services to enhance production efficiency and product quality.'
                },
                box2: {
                    title: 'Testing Center',
                    text: 'Offers comprehensive and precise testing services covering vegetables, fruits, aquatic products, livestock and other agricultural products.'
                },
                box3: {
                    title: 'Quality Evaluation Center',
                    text: 'Reveals the unique quality, taste and flavor of agricultural products - defining deliciousness scientifically and presenting excellence through data!'
                },
                btn: 'View Details'
            },
            module2: {
                imgBox1: {
                    imgT1: 'Agricultural Enterprise Digital Integration Platform',
                    imgT2: 'Connecting Future Agriculture for Efficient Precision Management',
                    text: 'Enables supply chain management, production monitoring, quality control, traceability and sales optimization through modules including product registration, digital farming management, quality assurance, traceability services and product listing. The data-driven platform ensures full-process transparency to enhance productivity and quality.'
                },
                imgBox2: {
                    imgT1: 'Government Industry Operations Platform',
                    imgT2: 'Smart Ecosystem for Efficient Operations & Sustainable Development',
                    text: 'Strengthens industry monitoring through big data and grid-based supervision, enhances quality control via certification and testing management, and optimizes resource allocation through operational services. The platform helps governments establish efficient regulatory and service systems to foster healthy industry development and regional competitiveness.'
                },
                btn: 'Enter Platform'
            }
        }
    }
}